<template>
  <div class="Privacy">
    <h1 class="title">易度网隐私政策</h1>
    <iframe
      src="https://eaydu-video.oss-cn-beijing.aliyuncs.com/privacy.pdf"
      width="100%"
      height="700"
    />
  </div>
</template>

<script>
export default {
  name: "Privacy",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.Privacy {
  width: 100%;
  padding: 110px 100px 20px;
  .title {
    margin-bottom: 20px;
  }
}
</style>
